import { useEffect, useRef, useState } from 'react';

interface UseScrollFadeOptions {
  threshold?: number;
  delay?: number;
}

const useScrollFade = (options: UseScrollFadeOptions = {}) => {
  const { threshold = 0.12, delay = 0 } = options;
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (delay > 0) {
            setTimeout(() => setIsVisible(true), delay);
          } else {
            setIsVisible(true);
          }
          observer.unobserve(element);
        }
      },
      { threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [threshold, delay]);

  // Returns Tailwind classes for the fade-in transition
  const fadeClass = `transition-all duration-[600ms] ease-out ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
  }`;

  return { ref, isVisible, fadeClass };
};

export default useScrollFade;
